// Shared open-event so the soft notice ("Manage") and the footer "Cookie
// preferences" link can surface the preferences dialog without importing the
// component — keeps CookiePreferencesModal.tsx component-only for fast refresh.
export const COOKIE_PREFS_EVENT = "adam:open-cookie-preferences";

export function openCookiePreferences(): void {
  try {
    window.dispatchEvent(new CustomEvent(COOKIE_PREFS_EVENT));
  } catch {
    /* non-browser env */
  }
}
